import './styles.css';

import React from 'react';
import ReactDOM from 'react-dom';
import Main from './comp/Main';
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
      <Router basename={ document['my-base-url'] }>
          <Main />
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
